import React from 'react';
import { LOADER_BLUE } from '../../constants/urls';
import { LoadContainer, LoadingText } from './styles';

interface LoaderProps{
    text:string;
    index:number;
}
const Loading : React.FC<LoaderProps> = ({ text,index }) => (
        <LoadContainer index={index}>
        <img src={LOADER_BLUE} 
        alt="" 
        width="32px"
        height="32px"
        />
        <LoadingText>{text}</LoadingText>
        </LoadContainer>
    );

export default Loading;
